import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import indexOf from 'lodash/indexOf';
import find from 'lodash/find';
import includes from 'lodash/includes';
import {
    DELIVERY_CHANGE_MESSAGE,
    ORDER_QUANTITY_CHANGE_WARNING,
    SHIPPING_GROUP_TYPE_HOME,
    SHIPPING_GROUP_TYPE_STORE,
    SHIPPING_GROUP_TYPE_BOPIS,
} from 'yoda-checkout-components/lib/common/Constants';
import Tooltip from 'yoda-core-components/lib/assets/svg/Tooltip.svg';
import S7Image from 'yoda-core-components/lib/components/S7Image/S7Image';
import Button from 'yoda-core-components/lib/components/Button';
import SelectDropdown from 'yoda-site-components/lib/components/SelectDropdown/SelectDropdown';
import {
    AMR_CART_ITEM_LEVEL_EDIT,
    AMR_CART_ITEM_LEVEL_SFL,
} from 'yoda-checkout-components/lib/common/AmrConstants';
import { navigateToPDPPageWithoutParams } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import {
    navigateToPDPPage,
    isExtensionRequired,
} from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import ProductAttributes from 'yoda-checkout-components/lib/components/ProductAttributes/ProductAttributes';
import ProductPriceStack from 'yoda-checkout-components/lib/components/ProductPriceStack/ProductPriceStack';
import ChildItemsGroup from 'yoda-checkout-components/lib/components/ChildItemsGroup/ChildItemsGroup';
import RecycleOrDisposableFeeMsg from 'yoda-checkout-components/lib/components/RecycleOrDisposableFeeMsg/RecycleOrDisposableFeeMsg';
import InventoryStatus from 'yoda-checkout-components/lib/components/InventoryStatus/InventoryStatus';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import IconTooltip from 'yoda-account-components/lib/components/IconTooltip/IconTooltip';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { saveForLaterCartItem } from '../../actions/SaveForLaterAction';
import { itemQuantityUpdate } from '../../actions/ItemQuantityUpdateAction';
import { updateCartItemInit } from '../../actions/CartItemsAction';
import RemoveItem from '../RemoveItem/RemoveItem';
import { ItemFulfillmentsNew } from '../../containers/Pages/Cart/LazyModules/CartPageWrapperComponentsLazy';
import ProductTypeUtils from '../../helpers/ProductTypeUtils/ProductTypeUtils';
import * as styles from './CartItem.css';

const cx = classNames.bind(styles);
export class CartItem extends Component {
    static propTypes = {
        index: PropTypes.number.isRequired,
        orderItem: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
        orderInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
        orderAdjustments: PropTypes.arrayOf(PropTypes.object).isRequired,
        currency: PropTypes.string,
        actions: PropTypes.objectOf(PropTypes.object).isRequired,
        updateCartItemInitValue: PropTypes.string,
        showGlobalLoader: PropTypes.bool,
        deviceType: PropTypes.objectOf(PropTypes.bool),
        quantityChangedItems: PropTypes.arrayOf(PropTypes.string),
        editCartToPDPNoAdditionalParams: PropTypes.bool,
        syndicateBrands: PropTypes.arrayOf(PropTypes.object),
        subDivisions: PropTypes.arrayOf(PropTypes.object).isRequired,
        enableMarketingLabel: PropTypes.bool,
        enableAddEditAdditionalServices: PropTypes.bool,
        enableFulfillmentOptionMessaging: PropTypes.bool,
        enableDiscontinuedItemsMessaging: PropTypes.bool,
    };

    static defaultProps = {
        currency: 'USD',
        updateCartItemInitValue: '',
        showGlobalLoader: false,
        deviceType: {},
        quantityChangedItems: [],
        editCartToPDPNoAdditionalParams: false,
        syndicateBrands: [],
        enableMarketingLabel: false,
        enableAddEditAdditionalServices: true,
        enableFulfillmentOptionMessaging: true,
        enableDiscontinuedItemsMessaging: true,
    };

    constructor() {
        super();
        this.state = {
            showPriceDetails: false,
        };
        this.saveForLater = this.saveForLater.bind(this);
        this.quantityChangeHandler = this.quantityChangeHandler.bind(this);
        this.renderModelNumber = this.renderModelNumber.bind(this);
        this.handlePDPLinkClick = this.handlePDPLinkClick.bind(this);
        this.renderItemModelToolTip = this.renderItemModelToolTip.bind(this);
        this.getQuantityDataSource = this.getQuantityDataSource.bind(this);
        this.renderRemoveButton = this.renderRemoveButton.bind(this);
        this.onPriceDetailsClickEvent = this.onPriceDetailsClickEvent.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showGlobalLoader && !isEmpty(prevProps.actions.updateCartItemInit)) {
            prevProps.actions.updateCartItemInit('');
        }
    }

    onPriceDetailsClickEvent() {
        this.setState({
            showPriceDetails: !this.state.showPriceDetails,
        });
    }

    getQuantityDataSource() {
        const { orderItem } = this.props;
        let { maxAllowableQuantity } = orderItem.product;
        // Overriding quantity if based on MOQ data at item level
        const selectedDeliveryOption =
            find(orderItem.deliveryOptions, { code: SHIPPING_GROUP_TYPE_HOME, selected: true }) ||
            find(orderItem.deliveryOptions, { code: SHIPPING_GROUP_TYPE_STORE, selected: true }) ||
            find(orderItem.deliveryOptions, { code: SHIPPING_GROUP_TYPE_BOPIS, selected: true });

        const selectedDeliveryOptionQty = get(selectedDeliveryOption, 'inventory.quantity');
        maxAllowableQuantity =
            selectedDeliveryOptionQty > 0 ? selectedDeliveryOptionQty : maxAllowableQuantity;
        // For OOS scenario maintain quantity provided by Aurora instead reset to 1
        if (!maxAllowableQuantity) {
            return [
                {
                    id: 1,
                    value: orderItem.quantity,
                },
            ];
        }

        const quantityDataSource = [...Array(parseInt(maxAllowableQuantity, 10))].map(
            (_, index) => ({
                id: index + 1,
                value: index + 1,
            })
        );
        return quantityDataSource;
    }

    /**
     * This state triggers a css collapse animation
     */
    collapse = () => {
        this.setState({
            isCollapsed: true,
        });
    };

    saveForLater = (e) => {
        e.preventDefault();
        const { orderItem } = this.props;
        const params = {};
        params.id = orderItem.id;
        params.postData = [
            {
                product: {
                    id: orderItem.product.id,
                },
                itemId: orderItem.sku.id,
                quantity: orderItem.quantity,
                attributes: orderItem.sku.attributes,
            },
        ];
        this.props.actions.showGlobalLoader(true);
        this.props.actions.saveForLaterCartItem(params);
    };

    /* istanbul ignore next */
    quantityChangeHandler = (qty) => {
        const { orderItem } = this.props;
        const payload = {
            id: orderItem.id,
            params: {
                skuId: orderItem.sku.id,
                ppId: orderItem.product.id,
                quantity: qty,
            },
        };

        this.props.actions.showGlobalLoader(true);
        this.props.actions.itemQuantityUpdate(payload);
    };

    handlePDPLinkClick = (e) => {
        e.preventDefault();

        /* istanbul ignore next */
        navigateToPDPPageWithoutParams(this.props.orderItem);
    };

    handlePDPEditLinkClick = (e) => {
        e && e.preventDefault && e.preventDefault();
        navigateToPDPPage(this.props.orderItem, this.props.editCartToPDPNoAdditionalParams);
    };

    renderItemModelToolTip = () => {
        const {
            product: { modelNumber, number },
        } = this.props.orderItem;
        let toolTipMsg = null;
        if (!isEmpty(number) && !isEmpty(modelNumber)) {
            toolTipMsg = `Item #${number} | Model #${modelNumber}`;
        } else if (!isEmpty(number)) {
            toolTipMsg = `Item #${number}`;
        } else if (!isEmpty(modelNumber)) {
            toolTipMsg = `Model #${modelNumber}`;
        }
        return (
            <span
                className={`${cx('svgDisplayInline')} ${dt(['mt-[1px]'])}`}
                data-automation-id="product-modal-num-tooltip"
            >
                {toolTipMsg && (
                    <IconTooltip
                        theme={dt(['!rounded', '!p-3', '!w-auto'])}
                        icon="tooltip"
                        iconComponent={<Tooltip />}
                        id="product-modal-num-tooltip"
                        tooltipBodyClassName={dt(['smOnly:-top-[1px]', 'sm:!z-[3]'])}
                        tooltipContentClass={dt([
                            'p-3',
                            'leading-5',
                            'rounded',
                            'bg-gray-70',
                            'border-gray-70',
                            this.props.index === 0 && this.props.deviceType.isDesktop
                                ? 'sm:ml-2'
                                : 'sm:ml-10',
                            'sm:w-[319px]',
                            'shadow-elevation1',
                            'text-sm',
                            'sm:!text-white',
                            'after:!border-solid',
                            'after:!border-[10px]',
                            'after:!border-l-transparent',
                            'after:!border-r-transparent',
                            'after:!border-t-gray-70',
                            'after:!border-b-transparent',
                            'before:!border-r-gray-70',
                        ])}
                        tooltipPlacement="Middle"
                        direction={
                            this.props.index === 0 && this.props.deviceType.isDesktop
                                ? 'Rightalign'
                                : 'Topmiddle'
                        }
                        alignAuto
                        iconClass={dt(['smOnly:!align-middle'])}
                        message={<span className={dt(['whitespace-nowrap','font-normal'])} dangerouslySetInnerHTML={{ __html: toolTipMsg }} />} // eslint-disable-line
                    />
                )}
            </span>
        );
    };

    renderModelNumber = () => {
        const {
            product: { modelNumber, type },
        } = this.props.orderItem;
        if (!ProductTypeUtils.isSilverProduct(type)) {
            return null;
        }
        return <div data-automation-id="at-model-number">Model #{modelNumber}</div>;
    };

    renderRemoveButton = (orderItem, bundleDiscountApplied, showSaveForLater, saveOrRemoveLink) => {
        return (
            <RemoveItem
                item={orderItem}
                index={this.props.index}
                linkAutoId="at-remove-item-link"
                modalAutoId="at-remove-item-modal"
                linkClass={`${cx(saveOrRemoveLink)} ${dt(['m-0'])}`}
                sflAction={this.saveForLater}
                bundleDiscountApplied={bundleDiscountApplied !== null && bundleDiscountApplied}
                showSaveForLater={showSaveForLater}
                collapseCartItem={this.collapse}
            />
        );
    };

    renderDeliveryChangeMessage = (deliveryMethodChanged) => {
        if (!deliveryMethodChanged) {
            return null;
        }

        return (
            <div className={dt(['md:my-2', 'p-0'])}>
                <MessageBox type="information" level="section" hasClose={false}>
                    <p>{DELIVERY_CHANGE_MESSAGE}</p>
                </MessageBox>
            </div>
        );
    };

    renderProductTitle = (productName, isSyndicateBrands) => {
        if (isSyndicateBrands) {
            return <span dangerouslySetInnerHTML={{ __html: productName }} />;
        }
        return productName;
    };

    renderCartItemCTA = (
        quantityDataSource,
        orderItem,
        bundleDiscountApplied,
        saveOrRemoveLink,
        showSaveForLater
    ) => {
        const { enableDiscontinuedItemsMessaging } = this.props;
        const isDiscontinuedItem = enableDiscontinuedItemsMessaging && orderItem.discontinued;
        const lowStockItem = quantityDataSource.length === 1 || isDiscontinuedItem;
        const saveForLater = 'Save';
        return (
            <div className={dt(['flex'])} data-automation-id="at-sfl-link-wrapper-sm">
                <div
                    className={`${cx('quantityWrapper')} ${dt([
                        'my-2',
                        'mx-0',
                        'mt-0',
                        'smOnly:w-[37%]',
                        'mdOnly:w-[16.2%]',
                        'lg:w-[25%]',
                        'md:pr-2',
                    ])}`}
                    data-automation-id="at-qty-wrapper-sm"
                >
                    <SelectDropdown
                        className={dt(['!w-20'])}
                        name="quantity"
                        datasource={quantityDataSource}
                        defaultValueRequired={false}
                        automationId="at-select-quantity"
                        optionDisplayValue="value"
                        optionValue="id"
                        onChangeHandler={this.quantityChangeHandler}
                        value={orderItem.quantity}
                        disabled={lowStockItem}
                    />
                </div>
                <div
                    className={`${cx('cartActionCTA')}
                        ${dt([
                            'my-2',
                            'mx-0',
                            'md:m-0',
                            'md:pl-2',
                            'md:py-2',
                            'text-right',
                            'flex',
                            'items-center',
                            'smOnly:w-[70%]',
                            'md:text-left',
                            'smOnly:clear-both',
                            'mdOnly:w-[61%]',
                            'lg:w-[52%]',
                            'smOnly:justify-end',
                        ])}`}
                >
                    {(bundleDiscountApplied === null || !bundleDiscountApplied) && (
                        <>
                            <div
                                className={`${cx('editButton')} ${dt([
                                    'inline-block',
                                    'text-left',
                                    'mr-8',
                                ])}`}
                                data-automation-id="at-edit-cart-item-wrapper-sm"
                            >
                                <div id={AMR_CART_ITEM_LEVEL_EDIT}>
                                    <Button
                                        automationId="at-edit-cart-item-link"
                                        buttonType="Link"
                                        size="Md"
                                        className={cx(saveOrRemoveLink)}
                                        onClick={this.handlePDPEditLinkClick}
                                    >
                                        Edit
                                    </Button>
                                </div>
                            </div>
                            {!isDiscontinuedItem && showSaveForLater && (
                                <div
                                    className={`${cx('sflButton')} ${dt([
                                        'inline-block',
                                        'pl-0',
                                        'text-left',
                                        'mr-8',
                                    ])}`}
                                    data-automation-id="at-sfl-btn-wrapper-sm"
                                >
                                    <div id={AMR_CART_ITEM_LEVEL_SFL}>
                                        {showSaveForLater && (
                                            <Button
                                                automationId="at-save-for-later-link"
                                                buttonType="Link"
                                                size="Md"
                                                className={cx(saveOrRemoveLink)}
                                                onClick={this.saveForLater}
                                            >
                                                {saveForLater}
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    <div
                        className={`${cx('removeButton', {
                            saveForLater: bundleDiscountApplied,
                        })} ${dt(['inline-block', 'text-right'])}`}
                        data-automation-id="at-remove-btn-block-sm"
                    >
                        {this.renderRemoveButton(
                            orderItem,
                            bundleDiscountApplied,
                            showSaveForLater,
                            saveOrRemoveLink
                        )}
                    </div>
                </div>
            </div>
        );
    };

    renderChildItemsGroup = (orderItem, childItemGroupConfig, actions, deviceType) => {
        const { enableAddEditAdditionalServices } = this.props;
        const isCarePlanEligible = get(orderItem, 'product.carePlanEligible', false);
        const isAdditionalServiceEligible = get(
            orderItem,
            'product.additionalServiceEligible',
            false
        );
        return (
            <ChildItemsGroup
                orderItem={orderItem}
                config={childItemGroupConfig}
                showEditAppliance
                enableAddEditAdditionalServices={enableAddEditAdditionalServices}
                handleEdit={actions.setEditSilverItemId}
                updateAction={actions.itemQuantityUpdate}
                deviceType={deviceType}
                isAdditionalServiceEligible={isAdditionalServiceEligible}
                isCarePlanEligible={isCarePlanEligible}
            />
        );
    };

    offerAdditionalServicesOnCart(orderItem) {
        const { enableAddEditAdditionalServices } = this.props;
        const isCarePlanEligible = get(orderItem, 'product.carePlanEligible', false);
        const isAdditionalServiceEligible = get(
            orderItem,
            'product.additionalServiceEligible',
            false
        );
        const isManufacturingWarrantyEligible = get(
            orderItem,
            'product.manufacturerWarranty',
            false
        );
        const isChildItemsEmpty = isEmpty(orderItem.childItems);
        const showAddtionalServices =
            enableAddEditAdditionalServices &&
            isChildItemsEmpty &&
            (isCarePlanEligible || isAdditionalServiceEligible);
        return !isChildItemsEmpty || showAddtionalServices || isManufacturingWarrantyEligible;
    }

    renderRecycleOrDisposableFeeMsg = ({
        isRecycleFeeEligible,
        isDisposalFeeEligible,
        orderItem,
    }) => {
        return (
            <div
                className={dt(['overflow-hidden', 'pb-2', 'clear-both'])}
                data-automation-id="at-product-price-recycle-fee-wrapper"
            >
                <RecycleOrDisposableFeeMsg
                    isRecycleFee={isRecycleFeeEligible}
                    isDisposableFee={isDisposalFeeEligible}
                    childItems={orderItem.childItems}
                />
            </div>
        );
    };

    renderCartItem() {
        const {
            orderItem,
            orderAdjustments,
            currency,
            updateCartItemInitValue,
            showGlobalLoader,
            actions,
            deviceType,
            quantityChangedItems,
            enableMarketingLabel,
            enableFulfillmentOptionMessaging,
            enableDiscontinuedItemsMessaging,
        } = this.props;
        const {
            product: {
                id,
                number,
                imageURL,
                name,
                url,
                isDisposalFeeEligible,
                isRecycleFeeEligible,
                brandName,
                subdivision,
                type,
            },
            sku: { attributes },
            product: { bundleDiscountApplied },
            deliveryMethodChanged,
        } = orderItem;
        const skuId = get(orderItem, 'sku.id');
        const quantityDataSource = this.getQuantityDataSource();
        const childItemGroupConfig = { displayParentProductNum: false };
        const isItemQuantityChanged = quantityChangedItems.indexOf(orderItem.id) !== -1;

        const isGiftCardItem = type === 'GIFTCARD';
        const isSyndicateBrands = includes(this.props.syndicateBrands, brandName);
        const productAttributesChanges = dt(['text-xsmall', 'text-gray-60', 'capitalize']);
        const saveOrRemoveLink = dt(['mx-0', 'my-2', 'text-left', '!text-base', '!leading-6']);
        const showSaveForLater = indexOf(this.props.subDivisions, subdivision) === -1;
        const { isCollapsed } = this.state;
        const isItemUpdateStart = !!(updateCartItemInitValue === orderItem.id && showGlobalLoader);
        const argsForRecycleDisposableComp = {
            isRecycleFeeEligible,
            isDisposalFeeEligible,
            orderItem,
        };

        return (
            <div
                className={`${dt([
                    'bg-white',
                    'border-b',
                    'border-gray-15',
                    'border-solid',
                    'mb-2',
                    'pb-2',
                    'lg:mr-4',
                    isCollapsed && 'm-0',
                    isCollapsed && 'p-0',
                    isCollapsed && 'max-h-0',
                    isCollapsed && 'overflow-hidden',
                    isItemUpdateStart && 'bg-opacity-70',
                    'opacity-100',
                    'max-h-[1200px]',
                ])}
                    ${cx('cartItemWrapper', 'cartSimplificationCartItemWrapper', {
                        // 'cart-progress-active': isItemUpdateStart,
                        collapsed: isCollapsed,
                    })}`}
                data-automation-id="at-cart-item-wrapper"
                ref={(input) => {
                    this.cartItemSection = input;
                }}
            >
                {isItemUpdateStart && <DelaySpinner section={this.cartItemSection} />}
                <div
                    data-automation-id="at-cart-item-details"
                    data-ppId={id}
                    data-webId={number}
                    data-skuId={skuId}
                />
                <div
                    className={`${cx('sm12', 'md12', 'lg12', 'xl12', 'no-padding')} ${dt([
                        'sm:!p-0',
                    ])}`}
                >
                    {isItemQuantityChanged && (
                        <MessageBox
                            type="warning"
                            level="section"
                            hasClose={false}
                            title={ORDER_QUANTITY_CHANGE_WARNING}
                        />
                    )}
                    <div className={dt(['m-0'])}>
                        {!enableFulfillmentOptionMessaging &&
                            this.renderDeliveryChangeMessage(deliveryMethodChanged)}
                    </div>
                    <div
                        className={`${cx('cartImgWrapper')} ${dt([
                            'float-left',
                            'mb-2',
                            'smOnly:w-[32%]',
                            'mdOnly:w-[16.2%]',
                            'lg:w-[25%]',
                            'md:pr-2',
                        ])}`}
                    >
                        <div data-automation-id="at-product-image" className={dt(['w-full'])}>
                            {bundleDiscountApplied ? (
                                <a href={url}>
                                    <S7Image
                                        automationId="view-at-product-image"
                                        src={imageURL}
                                        alt={name}
                                        extensionRequired={isExtensionRequired(subdivision)}
                                    />
                                </a>
                            ) : (
                                <a
                                    data-automation-id="at-product-image-link"
                                    href={url}
                                    onClick={this.handlePDPLinkClick}
                                >
                                    <S7Image
                                        automationId="view-at-product-image"
                                        src={imageURL}
                                        alt={name}
                                        extensionRequired={isExtensionRequired(subdivision)}
                                    />
                                </a>
                            )}
                            {!orderItem.discontinued &&
                            orderItem.inventory &&
                            (orderItem.inventory.status !== 'INSTOCK' ||
                                orderItem.inventory.status !== 'BACKORDERED') ? (
                                <InventoryStatus inventory={orderItem.inventory} />
                            ) : null}
                            {/** No Specific inventory status for Discontinue, to reuse <InventoryStatus>
                             * passing status as "DICONTINUED"
                             */}
                            {orderItem.discontinued && enableDiscontinuedItemsMessaging ? (
                                <InventoryStatus inventory={{ status: 'DISCONTINUED' }} />
                            ) : null}
                        </div>
                    </div>
                    <div
                        className={`${cx('cartProductSpace', 'hiddenSm')} ${dt([
                            'py-0',
                            'px-2',
                            'smOnly:clear-both',
                            'mdOnly:w-[61%]',
                            'lg:w-[52%]',
                            'md:float-left',
                        ])}`}
                    >
                        <div
                            className={dt(['text-medium', 'text-black'])}
                            data-automation-id="at-cart-item-desc-block"
                        >
                            <div>
                                <div
                                    className={cx('productInfoWrap')}
                                    data-automation-id="at-product-info-wrapper"
                                >
                                    <div
                                        data-automation-id="ocProductTitle"
                                        className={dt([
                                            'sm:text-lg',
                                            'sm:leading-7',
                                            'lg:text-medium',
                                            'lg:leading-6',
                                            'text-black',
                                            'font-open-sans-semibold',
                                        ])}
                                    >
                                        {bundleDiscountApplied ? (
                                            <a href={url}>
                                                <span
                                                    className={dt(['text-black'])}
                                                    data-automation-id="at-product-title-link"
                                                >
                                                    {this.renderProductTitle(
                                                        name,
                                                        isSyndicateBrands
                                                    )}
                                                </span>
                                            </a>
                                        ) : (
                                            <a
                                                className={dt(['text-black'])}
                                                title={name}
                                                data-automation-id="at-product-title-link"
                                                href={url}
                                                onClick={this.handlePDPLinkClick}
                                            >
                                                <span>
                                                    {this.renderProductTitle(
                                                        name,
                                                        isSyndicateBrands
                                                    )}
                                                </span>
                                            </a>
                                        )}
                                        &nbsp;&nbsp;
                                        {!__SERVER__ && this.renderItemModelToolTip()}
                                    </div>
                                    <div
                                        className={`${cx(
                                            'visibleSmMd',
                                            productAttributesChanges
                                        )} ${dt(['mt-1', 'text-left', 'text-xsmall'])}`}
                                        data-automation-id="at-product-attri-block-large"
                                    >
                                        {this.renderModelNumber()}
                                        <ProductAttributes
                                            isGiftCardItem={isGiftCardItem}
                                            attributes={attributes}
                                        />
                                    </div>
                                    <div>
                                        <div
                                            className={`${cx(
                                                'hiddenSm',
                                                'hiddenTwMd',
                                                productAttributesChanges
                                            )} ${dt(['mt-1', 'text-left'])}`}
                                            data-automation-id="at-product-attri-block-small"
                                        >
                                            {this.renderModelNumber()}
                                            <ProductAttributes
                                                isGiftCardItem={isGiftCardItem}
                                                attributes={attributes}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {enableFulfillmentOptionMessaging &&
                                    this.renderDeliveryChangeMessage(deliveryMethodChanged)}
                                <div
                                    className={`${cx('hiddenSm')} ${dt([
                                        'm-0',
                                        'md:my-4',
                                        'md:mx-0',
                                    ])}`}
                                    data-automation-id="at-item-fulfillment-wrapper"
                                >
                                    <div data-automation-id="at-item-fulfillment-block-wrapper">
                                        <ItemFulfillmentsNew
                                            itemData={orderItem}
                                            uniqueId="large"
                                        />
                                    </div>
                                </div>
                                {this.offerAdditionalServicesOnCart(orderItem) && (
                                    <div
                                        className={`${cx('childItemGroupWrap', 'hiddenSm')} ${
                                            ('pb-1', 'my-4', 'mx-0', 'w-full', 'overflow-hidden')
                                        }`}
                                        data-automation-id="at-child-item-group-wrapper"
                                    >
                                        {this.renderChildItemsGroup(
                                            orderItem,
                                            childItemGroupConfig,
                                            actions,
                                            deviceType
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={dt([
                            'float-left',
                            'text-right',
                            'smOnly:w-[68%]',
                            'mdOnly:w-[22.8%]',
                            'lg:w-[23%]',
                            'md:pl-2',
                        ])}
                        data-automation-id="at-product-price-wrapper"
                    >
                        <ProductPriceStack
                            orderItem={orderItem}
                            orderAdjustments={orderAdjustments}
                            currency={currency}
                            quantity={orderItem.quantity}
                            dividerTheme={styles.priceDivider}
                            showPriceDetailsBreakup={this.state.showPriceDetails}
                            onPriceDetailsClick={this.onPriceDetailsClickEvent}
                            toolTipId={`${orderItem.id}-mobile`}
                            showOversizedSurCharge
                            enableMarketingLabel={enableMarketingLabel}
                        />
                        {this.renderRecycleOrDisposableFeeMsg(argsForRecycleDisposableComp)}
                    </div>
                    <div
                        className={`${cx(
                            'cartProductSpace',
                            'hiddenXl',
                            'hiddenLg',
                            'hiddenTwMd'
                        )} ${dt([
                            'py-4',
                            'px-0',
                            'smOnly:clear-both',
                            'md:w-3/5',
                            'md:float-left',
                        ])}`}
                    >
                        <div
                            className={dt(['text-medium', 'text-black'])}
                            data-automation-id="at-cart-item-desc-block"
                        >
                            <div>
                                <div
                                    className={cx('productInfoWrap')}
                                    data-automation-id="at-product-info-wrapper"
                                >
                                    <div
                                        data-automation-id="ocProductTitle"
                                        className={dt([
                                            'sm:text-lg',
                                            'sm:leading-7',
                                            'lg:text-medium',
                                            'lg:leading-6',
                                            'text-black',
                                            'font-open-sans-semibold',
                                        ])}
                                    >
                                        {bundleDiscountApplied ? (
                                            <a href={url}>
                                                <span
                                                    className={dt(['text-black'])}
                                                    data-automation-id="at-product-title-link"
                                                >
                                                    {this.renderProductTitle(
                                                        name,
                                                        isSyndicateBrands
                                                    )}
                                                </span>
                                            </a>
                                        ) : (
                                            <a
                                                className={dt(['text-black'])}
                                                title={name}
                                                data-automation-id="at-product-title-link"
                                                href={url}
                                                onClick={this.handlePDPLinkClick}
                                            >
                                                <span>
                                                    {this.renderProductTitle(
                                                        name,
                                                        isSyndicateBrands
                                                    )}
                                                </span>
                                            </a>
                                        )}
                                        &nbsp;&nbsp;
                                        {!__SERVER__ && this.renderItemModelToolTip()}
                                    </div>
                                    <div
                                        className={`${cx(
                                            'visibleSmMd',
                                            productAttributesChanges
                                        )} ${dt([
                                            'mt-1',
                                            'text-left',
                                            'text-small',
                                            'sm:text-xsmall',
                                            'md:text-xsmall',
                                        ])}`}
                                        data-automation-id="at-product-attri-block-large"
                                    >
                                        {this.renderModelNumber()}
                                        <ProductAttributes
                                            isGiftCardItem={isGiftCardItem}
                                            attributes={attributes}
                                        />
                                    </div>
                                    <div>
                                        <div
                                            className={`${cx(
                                                'hiddenSm',
                                                'hiddenTwMd',
                                                productAttributesChanges
                                            )} ${dt([
                                                'mt-2',
                                                'text-left',
                                                'text-small',
                                                'sm:text-xsmall',
                                                'md:text-xsmall',
                                            ])}`}
                                            data-automation-id="at-product-attri-block-small"
                                        >
                                            {this.renderModelNumber()}
                                            <ProductAttributes
                                                isGiftCardItem={isGiftCardItem}
                                                attributes={attributes}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${cx('hiddenTwMd', 'hiddenXl', 'hiddenLg')} ${dt([
                            'm-0',
                            'md:my-4',
                            'md:mx-0',
                        ])}`}
                        data-automation-id="at-item-fulfillment-wrapper"
                    >
                        {enableFulfillmentOptionMessaging &&
                            this.renderDeliveryChangeMessage(deliveryMethodChanged)}
                        <div data-automation-id="at-item-fulfillment-block-wrapper">
                            <ItemFulfillmentsNew itemData={orderItem} uniqueId="mobile" />
                        </div>
                    </div>
                    {this.offerAdditionalServicesOnCart(orderItem) && (
                        <div
                            className={`${cx(
                                'childItemGroupWrap',
                                'hiddenTwMd',
                                'hiddenXl',
                                'hiddenLg'
                            )} ${dt(['mb-2'])}`}
                            data-automation-id="at-child-item-group-wrapper"
                        >
                            {this.renderChildItemsGroup(
                                orderItem,
                                childItemGroupConfig,
                                actions,
                                deviceType
                            )}
                        </div>
                    )}
                    <div className={dt(['clear-both'])}>
                        {this.renderCartItemCTA(
                            quantityDataSource,
                            orderItem,
                            bundleDiscountApplied,
                            saveOrRemoveLink,
                            showSaveForLater
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return this.renderCartItem();
    }
}
const mapStateToProps = (state) => {
    const { updateCartItemInitValue, showGlobalLoader, context, orderInfo, productDetails } = state;
    const editCartToPDPNoAdditionalParams = get(
        context,
        'featureFlags.editCartToPDPNoAdditionalParams',
        false
    );
    const syndicateBrands = get(context, 'preferences.syndicateBrands', '');
    const subDivisions = get(context, 'preferences.subDivisions', '');
    const enableMarketingLabel = get(context, 'featureFlags.enableMarketingLabel', false);
    const enableAddEditAdditionalServices = get(
        context,
        'featureFlags.enableAddEditAdditionalServices',
        true
    );
    const enableFulfillmentOptionMessaging = get(
        context,
        'featureFlags.enableFulfillmentOptionMessaging',
        true
    );
    const enableDiscontinuedItemsMessaging = get(
        context,
        'featureFlags.enableDiscontinuedItemsMessaging',
        true
    );

    return {
        orderInfo,
        updateCartItemInitValue,
        showGlobalLoader,
        editCartToPDPNoAdditionalParams,
        syndicateBrands,
        subDivisions,
        enableMarketingLabel,
        enableAddEditAdditionalServices,
        enableFulfillmentOptionMessaging,
        enableDiscontinuedItemsMessaging,
        productDetails,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            updateCartItemInit,
            itemQuantityUpdate,
            saveForLaterCartItem,
            ...showGlobalLoaderAction,
            ...siteAnalyticsAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartItem);
